// extracted by mini-css-extract-plugin
export var actionButton = "_ni-0";
export var actionMenuContainer = "_ni-i";
export var bubble = "_ni-2";
export var bubbleActionMenu = "_ni-j";
export var bubbleContext = "_ni-6";
export var bubbleItems = "_ni-7";
export var customer = "_ni-3";
export var divider = "_ni-8";
export var fileList = "_ni-9";
export var hiddenComment = "_ni-o";
export var infoAbove = "_ni-a";
export var internal = "_ni-4";
export var lightActionButton = "_ni-1";
export var link = "_ni-b";
export var merchant = "_ni-5";
export var message = "_ni-c";
export var profilePicture = "_ni-e";
export var quillToolbarContainer = "_ni-f";
export var senderDate = "_ni-g";
export var senderDateCustomer = "_ni-h";
export var senderName = "_ni-d";
export var time = "_ni-k";
export var uploadedImage = "_ni-l";
export var username = "_ni-m";
export var xsmall = "_ni-n";